export default "__VITE_ASSET__59333939__"